import { Button, Form, Input, Space, Switch, message } from "antd";
import AlarmContactApi from "../../../api/AlarmContactApi";
import React, { useEffect, useState } from "react";
import { CreateAlarmContactWrapper, EditFormLayout, EditFormRow, FormWrapper, OperationWrapper, Title, TitleWrapper } from "./CreateAlarmContact.styled";
import StringUtils from "../../../util/StringUtils";

interface CreateAlarmContactProps {
    alarmContactId: string;
    onClose: ()=> void,
    onComplete: ()=> void
}

const CreateAlarmContact: React.FC<CreateAlarmContactProps> = (props)=> {
    // api
    let alarmContactApi = new AlarmContactApi();
    const [messageApi, contextHolder] = message.useMessage();

    // state
    let [alarmContact, setAlarmContact] = useState<any>({
        name: '',
        phone: '',
        email: '',
        wecomWebhook: '',
        dingtalkWebhook: '',
        larkWebhook: '',
        remarks: '',
        enabled: true,
    });
    let [submitEnabled, setSubmitEnabled] = useState(false);
    const [form] = Form.useForm();

    // events
    let onNameChange = (e)=> {
        alarmContact.name = e.target.value;
        setAlarmContact({...alarmContact});
    };

    let onSMSChange = (e)=> {
        alarmContact.sms = e.target.value;
        setAlarmContact({...alarmContact});
    };

    let onEmailChange = (e)=> {
        alarmContact.email = e.target.value;
        setAlarmContact({...alarmContact});
    };

    let onWecomWebhookChange = (e)=> {
        alarmContact.wecomWebhook = e.target.value;
        setAlarmContact({...alarmContact});
    };

    let onDingtalkWebhookChange = (e)=> {
        alarmContact.dingtalkWebhook = e.target.value;
        setAlarmContact({...alarmContact});
    };

    let onLarkWebhookChange = (e)=> {
        alarmContact.larkWebhook = e.target.value;
        setAlarmContact({...alarmContact});
    };

    let onRemarksChange = (e)=> {
        alarmContact.remarks = e.target.value;
        setAlarmContact({...alarmContact});
    };

    let onEnabledChange = (checked)=> {
        alarmContact.enabled = checked;
        setAlarmContact({...alarmContact});
    };

    // methods
    let loadAlarmContact = async()=> {
        if (props.alarmContactId) {
            let alarmContact = (await alarmContactApi.get(props.alarmContactId)).data.data;
            setAlarmContact(alarmContact);
            form.setFieldsValue(alarmContact);
        }
    };

    let onSubmit = async ()=> {
        if (StringUtils.isEmpty(props.alarmContactId)) {
            await alarmContactApi.create(alarmContact);
        } else {
            await alarmContactApi.update(alarmContact);
        }
        messageApi.success('保存成功！');
        props.onComplete();
    };

    let onCancel = ()=> {
        props.onClose();
    };

    let validateForm = ()=> {
        form.validateFields().then((values)=> {
            setSubmitEnabled(true);
        }).catch((err)=> {
            setSubmitEnabled(false);
        });
    }

    // onload
    useEffect(()=> {
        loadAlarmContact();
    }, []);

    useEffect(()=> {
        validateForm();
    }, [alarmContact]);

    // render
    return <CreateAlarmContactWrapper>
        <TitleWrapper>
            <Title>{ props.alarmContactId ? '编辑联系人' : '新建联系人' }</Title>
            {contextHolder}
        </TitleWrapper>

        <FormWrapper>
            <Form form={form} name="alarm-contact" layout="vertical">
                <EditFormLayout>
                    <EditFormRow>
                        <Form.Item name="name" label="姓名" rules={[{required: true, message: '请输入姓名'}]}>
                            <Input
                                placeholder="请输入姓名"
                                value={alarmContact.name}
                                onChange={onNameChange}
                            />
                        </Form.Item>
                    </EditFormRow>

                    <EditFormRow>
                        <Form.Item name="sms" label="短信(手机号)" rules={[{required: false, message: '请输入手机号'}]}>
                            <Input
                                placeholder="请输入手机号"
                                value={alarmContact.sms}
                                onChange={onSMSChange}
                            />
                        </Form.Item>
                    </EditFormRow>

                    <EditFormRow>
                        <Form.Item name="email" label="邮箱" rules={[{required: false, message: '请输入邮箱'}, {type: 'email', message: '邮箱格式不正确'}]}>
                            <Input
                                placeholder="请输入邮箱"
                                value={alarmContact.email}
                                onChange={onEmailChange}
                            />
                        </Form.Item>
                    </EditFormRow>

                    <EditFormRow>
                        <Form.Item name="wecomWebhook" label="企业微信机器人" rules={[{required: false, message: '请输入企业微信WebHook'}]}>
                            <Input
                                placeholder="请输入企业微信WebHook"
                                value={alarmContact.wecomWebhook}
                                onChange={onWecomWebhookChange}
                            />
                        </Form.Item>
                    </EditFormRow>

                    <EditFormRow>
                        <Form.Item name="dingtalkWebhook" label="钉钉机器人" rules={[{required: false, message: '请输入钉钉WebHook'}]}>
                            <Input
                                placeholder="请输入钉钉WebHook"
                                value={alarmContact.dingtalkWebhook}
                                onChange={onDingtalkWebhookChange}
                            />
                        </Form.Item>
                    </EditFormRow>

                    <EditFormRow>
                        <Form.Item name="larkWebhook" label="飞书机器人" rules={[{required: false, message: '请输入飞书WebHook'}]}>
                            <Input
                                placeholder="请输入飞书WebHook"
                                value={alarmContact.larkWebhook}
                                onChange={onLarkWebhookChange}
                            />
                        </Form.Item>
                    </EditFormRow>

                    <EditFormRow>
                        <Form.Item name="remarks" label="备注" rules={[{required: false}]}>
                            <Input.TextArea style={{height: '50px'}} onChange={onRemarksChange} placeholder="请输入备注"/>
                        </Form.Item>
                    </EditFormRow>
                </EditFormLayout>
            </Form>
        </FormWrapper>

        <OperationWrapper>
            <Space size="middle">
                <Button type="primary" disabled={!submitEnabled} onClick={onSubmit}>确定</Button>
                <Button type="primary" danger onClick={onCancel}>取消</Button>
            </Space>
        </OperationWrapper>
    </CreateAlarmContactWrapper>
};

export default CreateAlarmContact;
